import { InsightsSummaryBuilder } from './insights-summary.builder';

export const builders: any[] = [InsightsSummaryBuilder];

export * from './insights-summary.builder';
